// Exports a shared ReactOnRails instance for registering
// multiple components with the same component store.
// https://github.com/shakacode/react_on_rails/issues/991#issuecomment-412157019

// eslint-disable-next-line global-require
const ReactComponentRegistry = global.ReactOnRails || require('react-on-rails').default;

export default ReactComponentRegistry;
